import { MouseEvent } from 'react';

export function handlerClick(e: MouseEvent) {
  e.stopPropagation();
}
